<template>
  <fragment>
    <v-navigation-drawer v-if="isTablet" v-model="openNavMobile" fixed temporary class="mobile-nav">
      <mobile-menu :menu-primary="menuPrimary" />
    </v-navigation-drawer>
    <v-app-bar
      v-scroll="handleScroll"
      :class="{ fixed: fixed }"
      class="header"
      fixed
      dense
      app
      height="auto"
    >
      <v-container>
        <div class="header-content">
          <nav class="nav-menu">
            <v-btn
              v-if="isTablet"
              :class="{ 'is-active': openNavMobile }"
              class="hamburger hamburger--spin mobile-menu"
              icon
              small
              @click.stop="handleToggleOpen"
            >
              <span class="hamburger-box">
                <span class="bar hamburger-inner" />
              </span>
            </v-btn>
            <div class="logo">
              <router-link :to="localePath(to)">
                <logo type="landscape" :name="name==''?$t('brand.name'):name" />
              </router-link>
            </div>
            <div class="main-menu" v-if="isDesktop && loaded">
              <header-menu :menu-primary="menuPrimary" />
            </div>
            <user-menu />
          </nav>
        </div>
      </v-container>
    </v-app-bar>
  </fragment>
</template>

<style lang="scss" scoped>
@import "./header-style.scss";
</style>

<script>
import Logo from "../Logo";
import UserMenu from "./TopNav/UserMenu";
import MixedNav from "./TopNav/MixedNav";
import MixedMobile from "./SideNav/MixedMobile";
import navMenu from "./data/single";

let counter = 0;
function createData(name, link, offset, external = false) {
  counter += 1;
  return {
    id: counter,
    name,
    link,
    offset,
    external
  };
}

export default {
  components: {
    "header-menu": MixedNav,
    "mobile-menu": MixedMobile,
    UserMenu,
    Logo
  },
  data() {
    return {
      fixed: false,
      loaded: false,
      openNavMobile: null,
      menuPrimary: []
    };
  },
  mounted() {
    this.loaded = true;
    this.menu.forEach(element => {
      if (typeof element === "string") {
        this.menuPrimary.push(
          createData(element, this.from + "#" + element, 100, false)
        );
      } else {
        this.menuPrimary.push(
          createData(element.name, element.link, 100, !!element.external)
        );
      }
    });
  },
  methods: {
    handleScroll: function() {
      if (window.scrollY > 100) {
        return (this.fixed = true);
      }
      return (this.fixed = false);
    },
    handleToggleOpen: function() {
      this.openNavMobile = !this.openNavMobile;
    }
  },
  props: {
    menu: {
      type: Array,
      default: () => navMenu
    },
    name: {
      type: String,
      default: () => ""
    },
    to: {
      type: String,
      default: () => "/#"
    },
    from: {
      type: String,
      default: () => "/"
    }
  },
  computed: {
    isTablet() {
      const mdDown = this.$store.state.breakpoints.mdDown;
      return mdDown.indexOf(this.$mq) > -1;
    },
    isDesktop() {
      const lgUp = this.$store.state.breakpoints.lgUp;
      return lgUp.indexOf(this.$mq) > -1;
    }
  }
};
</script>
